import { z } from 'zod';
const toolArgumentSchema = z.object({
    value: z.union([z.string(), z.number(), z.boolean()]),
    valueType: z.enum(['fixed_value', 'llm_value']),
    is_required: z.boolean(),
    argType: z.enum(['fixed', 'text', 'checkbox', 'number', 'list_key_value', 'choice']).optional(),
});
const dynamicNestedToolArgumentSchema = z.record(z.string(), toolArgumentSchema);
export const createToolSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    description: z.string().nullable(),
    tool_type_id: z.number(),
    arguments: dynamicNestedToolArgumentSchema,
});
export const updateToolSchema = z.object({
    id: z.number(),
    name: z.string().min(1, 'Name is required'),
    description: z.string().nullable(),
    tool_type_id: z.number(),
    arguments: dynamicNestedToolArgumentSchema,
});
export const duplicateToolSchema = z.object({
    newName: z.string().min(1, 'Name is required'),
});
